export default __webpack_public_path__ + "static/media/background-basic-auth.64e8d8ef.png";